import { render, staticRenderFns } from "./CreateMiscUploads.vue?vue&type=template&id=dc461b0e&scoped=true&"
import script from "./CreateMiscUploads.vue?vue&type=script&lang=js&"
export * from "./CreateMiscUploads.vue?vue&type=script&lang=js&"
import style0 from "./CreateMiscUploads.vue?vue&type=style&index=0&id=dc461b0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc461b0e",
  null
  
)

export default component.exports